export default __webpack_public_path__ + "static/media/blog17.07baae1d.jpg";